import type { ReactNode } from "react"

import type { LucideIcon } from "@/components/icons"

import { cn } from "@/lib/utils"

type EmptyStateProps = {
  icon: LucideIcon
  title: string
  description?: string
  primaryAction?: ReactNode
  secondaryAction?: ReactNode
  className?: string
}

export function EmptyState({
  icon: Icon,
  title,
  description,
  primaryAction,
  secondaryAction,
  className = "",
}: EmptyStateProps) {
  return (
    <div
      className={cn("flex flex-col items-center justify-center gap-4 py-12 text-center", className)}
    >
      <div className="bg-muted flex size-16 items-center justify-center rounded-lg">
        <Icon className="text-muted-foreground size-8" />
      </div>
      <div className="space-y-1">
        <p className="text-base font-semibold">{title}</p>
        {description && <p className="text-muted-foreground max-w-sm text-sm">{description}</p>}
      </div>
      {(primaryAction || secondaryAction) && (
        <div className="flex flex-col items-center gap-2 sm:flex-row">
          {primaryAction}
          {secondaryAction}
        </div>
      )}
    </div>
  )
}
